import React from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import styles from "../src/styles/About_us.module.css";
import {
  FaBatteryFull,
  FaExchangeAlt,
  FaHandHoldingUsd,
  FaShieldAlt,
  FaStore,
  FaShoppingCart, // آیکون جدید برای فرایند خرید
} from "react-icons/fa";

const About_us = () => {
  return (
    <div className={styles.aboutContainer}>
      <Navbar />

      <div className={styles.heroSection}>
        <h1>شرح خدمات و تعهدات ما</h1>
        <p>
          تخصص ما در ارائه بهترین خدمات باتری های یو پی اس و باتری های خودرو با
          کیفیت و قیمت مناسب
        </p>
      </div>

      <div className={styles.aboutIntro}>
        <h2>درباره باتری۱۰۰ - Battery100.ir</h2>
        <p>
          در باتری۱۰۰ (Battery100.ir)، ما به عنوان مرجعی تخصصی برای خرید و فروش
          انواع باتری خودرو و باتری UPS فعالیت می‌کنیم. هدف ما ارائه محصولات با
          کیفیت بالا، قیمت‌های رقابتی و خدمات مشتری بی‌نظیر است تا تجربه‌ای آسان
          و مطمئن را برای شما فراهم آوریم. با سال‌ها تجربه در این حوزه، به خود
          می‌بالیم که نیازهای شما را در زمینه انرژی خودرو و سیستم‌های پشتیبانی
          برق به بهترین نحو پاسخگو باشیم.
        </p>
      </div>

      {/* بخش جدید درباره فرایند خرید */}
      <div className={styles.purchaseProcessSection}>
        <div className={styles.purchaseProcessCard}>
          <FaShoppingCart className={styles.processIcon} />
          <h3>فرایند خرید آسان و مطمئن</h3>
          <p>
            در باتری۱۰۰، خرید باتری مورد نیاز شما بسیار ساده و بی‌دردسر است.
            نیازی به ثبت نام در سایت نیست و شما می‌توانید به راحتی محصولات را به
            سبد خرید خود اضافه کرده و سفارش دهید. هیپ پرداختی به صورت آنلاین
            انجام نمی‌شود و شما می‌توانید هزینه را در محل و پس از تحویل کالا
            پرداخت کنید. ما این اطمینان را به شما می‌دهیم که فرایند خرید، تحویل
            و پرداخت با نهایت سهولت و امنیت انجام خواهد شد.
          </p>
        </div>
      </div>

      <div className={styles.servicesSection}>
        <div className={styles.serviceCard}>
          <FaExchangeAlt className={styles.serviceIcon} />
          <h3>تعویض باتری در محل</h3>
          <p>خدمات سریع و کارشناسی در محل شما</p>
        </div>

        <div className={styles.serviceCard}>
          <FaHandHoldingUsd className={styles.serviceIcon} />
          <h3>خرید اسقاط باتری</h3>
          <p>خرید باتری مستعمل با بالاترین قیمت</p>
        </div>

        <div className={styles.serviceCard}>
          <FaBatteryFull className={styles.serviceIcon} />
          <h3>فروش باتری بدون داغی</h3>
          <p>فروش باتری با قیمت منصفانه و تضمین کیفیت</p>
        </div>

        <div className={styles.serviceCard}>
          <FaShieldAlt className={styles.serviceIcon} />
          <h3>گارانتی شرکتی</h3>
          <p>تمامی باتری ها با گارانتی معتبر ارائه می‌شوند</p>
        </div>

        <div className={styles.serviceCard}>
          <FaStore className={styles.serviceIcon} />
          <h3>همکاری با مغازه داران</h3>
          <p>همکاری در خرید و فروش عمده باتری</p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About_us;
